import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/var/www/share/mysofabed.de/app/layouts/account.vue").then(m => m.default || m)),
  checkout: defineAsyncComponent(() => import("/var/www/share/mysofabed.de/app/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/share/mysofabed.de/app/layouts/default.vue").then(m => m.default || m))
}